// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 175) return "static/chunks/175-42ba43b7d5dcb1e3.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "0d2f2343008eba07" + ".js";
};